import { Box, Modal } from '@mui/material'
import React from 'react'
import RedemptionsImage from '../assets/imgs/profile-screen-images/redemptions-image.svg'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const RedemptionsModal = ({
  toggleRedemptionsModal,
  handleRedemptionsModal,
}) => {
  return (
    <div>
      <Modal
        open={toggleRedemptionsModal}
        onClose={() => handleRedemptionsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="m-0 text-center">
            <h3 className="fs-24 font-weight-bold">Redemptions</h3>
            <img
              src={RedemptionsImage}
              className="my-3"
              alt="Redemptions Image"
            />
            <p className="fs-24 color-primary mt-3">Oops!</p>
            <p className="fs-14 mt-2 color-primary">Nothing to redeem</p>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default RedemptionsModal
